export const invitaciones2024 = [
  {
    titulo: "Aun no hay invitaciones",
    subtitulo: [
      // {
      //   informacionTitulo: "EA-913005999-N1-2024",
      // },
    ],
  },
];
